export default () => (str) => {
  switch (str) {
    case '':
    case '*':
      return 'Default';
    default:
      return str;
  }
};
